import {
  SUPPORTED_LOCALE,
  SUPPORTED_LOCALES_SUBSET,
  supportedLocales,
} from '@travelwin/core';
import { type i18n } from 'i18next';

export const getSupportedLocales = (i18n: i18n): SUPPORTED_LOCALES_SUBSET => {
  const currentLocales = i18n.options.supportedLngs;

  if (!Array.isArray(currentLocales)) {
    return [];
  }

  return currentLocales.filter((locale) => supportedLocales.includes(locale));
};

export const getCurrentLocale = (i18n: i18n) => {
  return i18n.language as SUPPORTED_LOCALE;
};
